// Generated by ReScript, PLEASE EDIT WITH CARE


var placeholder = (require("./img/placeholder.svg").default);

var ImagesSVG = {
  placeholder: placeholder
};

export {
  ImagesSVG ,
  placeholder ,
}
/* placeholder Not a pure module */
